import { ContestType } from '@betterpool/api-types/contests-service';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

import type { SlateWithStateAndSettingsTeamPickEm } from '../../../../teamPickEm/parsers/parseSlatesTeamPickEm';
import parseTeamPickEmSlates from '../../../../teamPickEm/parsers/parseSlatesTeamPickEm';
import type { SlateWithStateAndSettingsTeamSurvivor } from '../../../../teamSurvivor/parsers/parseSlatesTeamSurvivor';
import parseTeamSurvivorSlates from '../../../../teamSurvivor/parsers/parseSlatesTeamSurvivor';
import type { SlateWithStateAndSettingsPlayerTier } from '../../../../playerTier/parsers/parseSlatesPlayerTier';
import parsePlayerTierSlates from '../../../../playerTier/parsers/parseSlatesPlayerTier';
import type { SlateWithStateAndSettingsPlayerSurvivor } from '../../../../playerSurvivor/parsers/parsePlayerSurvivorSlates';
import parsePlayerSurvivorSlates from '../../../../playerSurvivor/parsers/parsePlayerSurvivorSlates';

import type { SlateWithStateAndSettingsUnknownType } from './parseBaseSlate';
import parseSlateBase from './parseBaseSlate';

type SlateWithStateAndSettings =
  | SlateWithStateAndSettingsUnknownType
  | SlateWithStateAndSettingsPlayerTier
  | SlateWithStateAndSettingsTeamPickEm
  | SlateWithStateAndSettingsTeamSurvivor
  | SlateWithStateAndSettingsPlayerSurvivor;

const parseSlates = (
  contest: FullContest,
  slates: ContestSlate[] = []
): SlateWithStateAndSettings[] => {
  switch (contest.contest_type) {
    case ContestType.PLAYER_TIER:
    case ContestType.PLAYER_ONE_AND_DONE: {
      return parsePlayerTierSlates(contest, slates);
    }
    case ContestType.TEAM_SURVIVOR: {
      return parseTeamSurvivorSlates(contest, slates);
    }
    case ContestType.TEAM_PICK_EM: {
      return parseTeamPickEmSlates(contest, slates);
    }
    case ContestType.PLAYER_SURVIVOR: {
      return parsePlayerSurvivorSlates(contest, slates);
    }
    default: {
      return slates.map((slate, index) => parseSlateBase(contest, slate, index));
    }
  }
};

export default parseSlates;

export type { SlateWithStateAndSettings, SlateWithStateAndSettingsUnknownType };
